// Default algorithm list - fallback when API request fails
export const DEFAULT_ALGORITHMS = {
  'connection_shortest_path': {
    name: 'Connection-Based Shortest Path Algorithm',
    description: 'Find shortest duration path using predefined connections',
    connection_based: true,
    requires_connections: true,
    requires_demand: false
  },
  'capacity_constrained_shortest_path': {
    name: 'Capacity-Constrained Shortest Path Algorithm',
    description: 'Find optimal path considering transport capacity constraints and calculate required trips',
    connection_based: true,
    requires_connections: true,
    requires_demand: true
  }
}; 